module.exports = __webpack_public_path__ + "static/sunday-times-5542b3933acc5509230c3dc966b91f93.svg";